import classNames from 'classnames'
import React, { MouseEventHandler, ReactNode, forwardRef } from 'react'

import styles from './IconButton.module.scss'

const iconSizes = ['small', 'medium', 'large'] as const
export type IconSize = typeof iconSizes[number]

type Props = {
  className?: string
  enabled?: boolean
  icon?: ReactNode
  size?: IconSize
  isHoverWhite?: boolean
  order?: number
  color?: string | undefined
  onClick?: (e?: any) => void
  onMouseDown?: MouseEventHandler<HTMLDivElement>
  cursoring?: boolean
  onDrag?: (e?: any) => void
}

const IconButtonLight = forwardRef(
  (
    { className, size, isHoverWhite, enabled, cursoring, order, onClick, onMouseDown, onDrag, icon, ...props }: Props,
    ref: any,
  ) => {
    return (
      <div
        {...props}
        ref={ref}
        style={{ order: order }}
        onClick={enabled ? onClick : () => void 0}
        onMouseDown={enabled ? onMouseDown : () => void 0}
        className={classNames(
          styles.container,
          className,
          styles[size || 'small'],
          { [styles.isHoverWhite]: isHoverWhite },
          { [styles.isHoverBlack]: !isHoverWhite },
          { [styles.enabled]: enabled },
          { [styles.cursoring]: cursoring },
        )}
        onDrag={onDrag}
      >
        {icon}
      </div>
    )
  },
)

IconButtonLight.defaultProps = {
  className: '',
  enabled: true,
  icon: 'close',
  size: 'small',
  color: undefined,
  cursoring: true,
  isHoverWhite: true,
  order: 0,
  onClick: () => void 0,
  onDrag: () => void 0,
}

export default IconButtonLight
